export enum SuccessStatus {
	Ok = 200,
	Created = 201,
	Accepted = 202,
	NoContent = 204,
}

export enum RedirectionStatus {
	MultipleChoices = 300,
	MovedPermanently = 301,
	Found = 302,
	SeeOther = 303,
	NotModified = 304,
	TemporaryRedirect = 307,
	PermanentRedirect = 308,
}

export enum ErrorStatus {
	BadRequest = 400,
	Unauthorized = 401,
	Forbidden = 403,
	NotFound = 404,
	Conflict = 409,
	InternalServerError = 500,
	ServiceUnavailable = 503,
	GatewayTimeout = 504,
}

export type ResponseStatus = SuccessStatus | RedirectionStatus | ErrorStatus;
